import BillingInfoForm from 'components/PaymentData/BillingInfoForm/styled';

export default BillingInfoForm;
